export default "/images/vendor/flag-icon-css/flags/4x3/sm.svg?837e64d2a14911c7380d8af509b377a6";